export default [
  {
    path: '/shop/home',
    name: 'shop-home',
    component: () => import('@/views/shop/ShopCustom.vue'),
  },
  {
    path: '/shop/view',
    name: 'shop-view',
    component: () => import('@/views/shop/ShopView.vue'),
  },
  {
    path: '/shop/edit/:id',
    name: 'shop-edit',
    component: () => import('@/views/shop/ShopEdit.vue'),
  },

  {
    path: '/shop/products/:id',
    name: 'shop-products',
    component: () => import('@/views/shop/ShopFormWizard.vue'),
  },
]
